import { useCallback, useState } from 'react';

export type SortDirection = 'ASC' | 'DESC';

export type SortHandling<T> = {
    sortBy: T | null;
    setSortBy: (sortBy: T | null) => void;
    sortDirection: SortDirection | null;
    setSortDirection: (direction: SortDirection | null) => void;
    toggleDirection: () => void;
};

export const useSorting = <T>(
    initialSortBy?: T | null,
    initialSortDirection: SortDirection | null = 'ASC',
): SortHandling<T> => {
    const [sortBy, setSortBy] = useState<T | null>(initialSortBy ?? null);
    const [sortDirection, setSortDirection] = useState<SortDirection | null>(initialSortDirection);

    const toggleDirection = useCallback(() => {
        setSortDirection((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
    }, []);

    return {
        sortBy,
        setSortBy,
        sortDirection,
        setSortDirection,
        toggleDirection,
    };
};
